import { render, staticRenderFns } from "./joinTeamButton.vue?vue&type=template&id=3aa420aa&scoped=true&"
import script from "./joinTeamButton.vue?vue&type=script&lang=js&"
export * from "./joinTeamButton.vue?vue&type=script&lang=js&"
import style0 from "./joinTeamButton.vue?vue&type=style&index=0&id=3aa420aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa420aa",
  null
  
)

export default component.exports